import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Home from './components/Home';
import Overview from './components/Overview';
import TopNav from './components/TopNav';
import StartMining from './components/StartMining';
import Privacy from './components/Privacy';
import Terms from './components/Terms';
import Footer from './components/Footer';

function App() {
  return (
    <Router>
      <div className="app-container">
        <TopNav />
        <main className="content">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/start-mining" element={<StartMining />}/>
            <Route path="/overview" element={<Overview />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/privacy" element={<Privacy />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;